export const recycleColumns = [
  {
    label: "工作表",
    type: "sheetName",
    width: "120"
  },
  {
    label: "标题",
    type: "title",
    width: "120"
  },
  {
    label: "操作人",
    type: "user.name",
    width: "120"
  },
  {
    label: "操作时间",
    type: "createAt",
    width: "120"
  }
]
